var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4"},[_c('h3',{staticClass:"font-weight-700 text-dark mb-0"},[_vm._t("title",function(){return [(_vm.icon)?_c('i',{staticClass:"text-primary fa-fw mr-3",class:_vm.icon}):_vm._e(),_vm._v(_vm._s(_vm.title)+" ")]})],2),_c('div',{staticClass:"buttons"},[_vm._t("buttons")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }